<template>
  <div class="product-list-container">
    <nav class="add-navigation flex-wrap flex">
      <div @click="$router.push({name: 'company-admin-recipients'})" class="back-link ">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
              d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
              id="path-1"
          ></path>
        </svg>
        <p class="white_space">Back to Recipients</p>
      </div>
      <div class="buttons-wrapper flex-wrap">
        <div @click="$router.push({name: 'company-admin-recipients'})" class="secondary-button my-2 my-md-0">
          <secondary-button class="button_size">Cancel</secondary-button>
        </div>
        <div class="primary-button my-2 my-md-0">
          <primary-button @click.native="uploadFile" class="button">Import</primary-button>
        </div>
      </div>
    </nav>
    <div class="row">
      <div class="col-md-6 col-12">
        <primary-select
            type="text"
            name="DID auto create"
            class="select input_text_file"
            v-validate="'required'"
            v-model="did_auto_create"
            :class="{'input': true, 'is-danger': errors.has('DID auto create')}"
            placeholder="DID auto create">
          <option>true</option>
          <option>false</option>
        </primary-select>
        <div v-if="errors.has('DID auto create')" class="help is-danger">
          {{ errors.first('DID auto create') }}
        </div>
        <div
            class="help is-danger"
            v-if="errorsArray">{{ errorsArray.DID_auto_create ? errorsArray.DID_auto_create : null }}
        </div>

        <primary-select
            type="text"
            name="duplicate"
            class="select input_text_file"
            v-validate="'required'"
            v-model="duplicates_action"
            :class="{'input': true, 'is-danger': errors.has('duplicate')}"
            placeholder="Duplicate">
          <option
              v-for="(i, k) in duplicateTypes"
              :value="i"
              :key="k">{{ i }}
          </option>
        </primary-select>
        <div v-if="errors.has('duplicate')" class="help is-danger">{{ errors.first('duplicate') }}</div>
        <div
            class="help is-danger"
            v-if="errorsArray">{{ errorsArray.duplicate ? errorsArray.duplicate : null }}
        </div>
      </div>
      <div class="col-md-6 col-12  ">
        <div class="upload-container input_text_file">
          <app-dropzone
              @fileAdd="fileAdded($event)"
              @remove="fileRemoved($event)"
              class="dimension"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  data: () => ({
    file: null,
    errorsArray: [],
    duplicateTypes: ['skip', 'override'],
    duplicates_action: 'skip',
    did_auto_create: true,
  }),
  methods: {
    fileAdded(file) {
      console.log(file);
      if (file.accepted) {
        this.file = file;
        this.enabledUpload = false;
      }
    },
    fileRemoved() {
      this.file = null;
    },
    uploadFile () {
      let data = new FormData();

      data.append("file", this.file);
      data.append("type", "application/vnd.ms-excel");
      data.append("company_uuid", this.$store.getters.getCompany.company_uuid);
      data.append("did_auto_create", this.did_auto_create);
      data.append("duplicates_action", this.duplicates_action);

      this.$store
          .dispatch("UploadRecipientFile", data)
          .then(res => {
            this.fileRemoved();
            this.file = res.data.object_uuid;
          });
      try {

        this.$router.push({name: "company-admin-recipients-list"});
        this.$snotify.success("Recipient file imported.", {
          timeout: 6000
        });


      } catch (err) {
        if (err.errors) {
          this.errorsArray = err.errors[0].contact
              ? err.errors[0].contact
              : null;
          setTimeout(() => {
            this.errorsArray = null;
          }, 6000);
        } else if (err.response) {
          this.$snotify.error(
              err.response.data.errors
                  ? err.response.data.errors
                  : err.response.data.error.message, {timeout: 6000});
        } else {
          this.$snotify.error(err, {timeout: 6000});
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list-container {
  padding:0 20px;

  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;

    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;

      p {
        margin-bottom: 0;
      }
    }

    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;

      .primary-button {
        height: 40px;
        width: 130px;
      }

      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }

  .table {
    margin-top: 20px;
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 400px;
    padding-right: 20px;
    box-sizing: border-box;

    .first {
      min-width: fit-content;
      width: calc(20% - 7.5px);
      height: 100%;
      display: flex;
      flex-direction: column;
      margin-right: 20px;

      .upload-container {
        height: 300px;
        width: 350px;

        #dropzone {
          height: 300px;

          img {
            width: 300px;
            height: 260px;
          }

          .dz-details {
            width: 300px;
            height: 260px;
          }

          .dz-remove {
            width: 270px;
            height: 240px;
            margin-top: 15px;
            margin-bottom: 15px;
          }
        }
      }

      .select {
        width: 350px;
        margin-bottom: 20px;
      }
    }

    .button-container {
      display: flex;
      justify-content: flex-end;
      flex-direction: row;

      .button {
        margin-top: 20px;
        height: 40px;
        width: 130px;
      }
    }
  }
}

@media (max-width: 339px) {

  .button_size {
    min-width: 130px!important;
  }
}
.input_text_file{
  margin-top: 30px;
}
</style>

